// extracted by mini-css-extract-plugin
export default {"modal":"index_modal__KBOqd","subTitle":"index_subTitle__h7mfV","cancel":"index_cancel__9ec2x"};